import { useTranslation } from "react-i18next";

interface TOCItem {
  id: string;
  title: string;
  level: number;
}

interface DocsTOCProps {
  items: TOCItem[];
  activeId?: string;
}

export function DocsTOC({ items, activeId }: DocsTOCProps) {
  const { t } = useTranslation();

  if (items.length === 0) return null;

  return (
    <div>
      <h4 className="text-xs font-semibold uppercase tracking-wider text-warm-500 mb-4">
        {t("docs.toc.onThisPage")}
      </h4>
      <ul className="space-y-2">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`block text-sm transition-colors ${
                activeId === item.id
                  ? "text-warm-100 border-l-2 border-warm-500 pl-3 -ml-3"
                  : "text-warm-500 hover:text-warm-100 pl-3 -ml-3 border-l-2 border-transparent"
              }`}
              style={{ paddingLeft: `${(item.level - 1) * 8 + 12}px`, marginLeft: "-12px" }}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
